import { render, staticRenderFns } from "./StockPage.vue?vue&type=template&id=f8ba19a0&scoped=true&"
import script from "./StockPage.vue?vue&type=script&lang=js&"
export * from "./StockPage.vue?vue&type=script&lang=js&"
import style0 from "./StockPage.vue?vue&type=style&index=0&id=f8ba19a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ba19a0",
  null
  
)

export default component.exports